module.exports = __webpack_public_path__ + "static/media/Illustration_AIGA.0e70b6af.svg";